import type { ActionCodeSettings } from 'firebase/auth';

export const PASSWORD_RESET_ACTION_CODE_SETTINGS: ActionCodeSettings = {
  url: 'https://tonyte.app/reset-password',
  handleCodeInApp: false,
};
